/*
 * Created by Tigran Yengibaryan
 * Created on 11/06/2021 13:37
 *
 * Copyright (c) 2021 PicsArt.Inc
 */

import styled from 'styled-components';
import { useRecoilState } from 'recoil';
import { backgroundType } from '../models';
import { PageTitle } from '../components/PageTitle';
import firstIcon from '../assets/patterns/1.png';
import secondIcon from '../assets/patterns/2.png';
import thirdIcon from '../assets/patterns/3.png';
import sixthIcon from '../assets/patterns/6.png';
import image1 from '../assets/patterns/33.png';
import image2 from '../assets/patterns/Mask Group.png';
import image3 from '../assets/patterns/11.png';
import image4 from '../assets/patterns/Screenshot 2020-07-29 13.44.57.png';

const ClickableGroup = styled.button<{ selected: boolean }>`
  all: unset;
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  background: #ffffff;
  border-radius: 16px;
  box-sizing: border-box;
  border-width: 3px;
  border-style: solid;
  border-color: ${props => (props.selected ? '#3A76E8' : 'transparent')};
  transition: all ease-in 0.2s;
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  box-shadow: 0 0 13px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: ${props => (props.selected ? '#3A76E8' : '#dcdde9')};
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.05);
  }
`;

const Content = styled.div`
  box-sizing: border-box;
  height: calc(100vh - 160px);
  padding-top: 20px;
  padding-bottom: 100px;
`;

const CardTitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  color: #626777;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 32px;
  margin: 16px auto 0;
`;

const Card = styled.div`
  background: #f8f8f8;
  border-radius: 16px;
  width: 220px;
  height: 172px;
`;

const CardList = styled.div`
  all: unset;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: fit-content;
  grid-gap: 8px;
`;

const CardListWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
`;

export const BackgroundStyle = () => {
  const [selectedType, setBgType] = useRecoilState(backgroundType);

  return (
    <Content>
      <PageTitle text="Choose Your Visual Style" />
      <CardListWrapper>
        <ClickableGroup selected={selectedType === 'pattern'} onClick={() => setBgType('pattern')}>
          <CardList>
            <Card>
              <img src={firstIcon} width={220} height={160} />
            </Card>
            <Card>
              <img src={secondIcon} width={220} height={160} />
            </Card>
            <Card>
              <img src={thirdIcon} width={220} height={160} />
            </Card>
            <Card>
              <img src={sixthIcon} width={220} height={160}  />
            </Card>
          </CardList>
          <CardTitle>Pattern Composer</CardTitle>
        </ClickableGroup>
        <ClickableGroup selected={selectedType === 'sticker'} onClick={() => setBgType('sticker')}>
          <CardList>
            <Card>
              <img src={image1} width={220} height={160}  />
            </Card>
            <Card>
              <img src={image2} width={220} height={160}  />
            </Card>
            <Card>
              <img src={image4} width={220} height={160}  />
            </Card>
            <Card>
              <img src={image3} width={220} height={160}  />
            </Card>
          </CardList>
          <CardTitle>Content Arrangement</CardTitle>
        </ClickableGroup>
      </CardListWrapper>
    </Content>
  );
};
